import { render, staticRenderFns } from "./TestReportListPopup.vue?vue&type=template&id=89a9e870&scoped=true&"
import script from "./TestReportListPopup.vue?vue&type=script&lang=js&"
export * from "./TestReportListPopup.vue?vue&type=script&lang=js&"
import style0 from "./TestReportListPopup.vue?vue&type=style&index=0&id=89a9e870&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a9e870",
  null
  
)

export default component.exports